export enum UserMutationTypes {
  SET_USERINFO = 'SET_USERINFO',
  SET_TOKEN = 'SET_TOKEN',
  SET_USERID = 'SET_USERID',
  SET_ACCOUNT = 'SET_ACCOUNT',
  SET_LOGIN_SUCC = 'SET_LOGIN_SUCC',
  SET_SHOW_LOGIN_DIALOG = 'SET_SHOW_LOGIN_DIALOG',
  SET_IS_KEEP_LOGIN = "SET_IS_KEEP_LOGIN"
}
